module.exports = __webpack_public_path__ + "img/sch5-gift.70d95743.png";